export default "<p>smartfeed-amazon-dash-replenishment works!</p>\n"